// test2267
(2267 && 0);
